








import { Component, Vue } from 'vue-property-decorator';
import enquiryForm from '@/components/enquiry-form.vue';

@Component({
    components: {
        enquiryForm,
    },
})
export default class CreateEnquiry extends Vue {
    public handleEnquirySaved(id: string): void {
        this.$router.push({ name: 'view-enquiry', params: { id: id } });
    }
}
